import XmlService from './XmlService.js';

export default XmlService;